/**
 * Shared API origin for REST and Socket.IO.
 * - Dev with no VITE_API_BASE_URL: '' so Vite proxies `/api` to the backend.
 * - Production: set VITE_API_BASE_URL to your API origin (no trailing slash).
 *   Vite inlines this at build time — Cloudflare Pages must have it set on the build, then rebuild.
 */
const resolvedBase =
    import.meta.env.VITE_API_BASE_URL ||
    (import.meta.env.DEV ? '' : 'http://localhost:9090');

export const API_BASE_URL = String(resolvedBase).replace(/\/+$/, '');

/** Socket.IO connects to the API host (not the Vite dev origin when using the proxy). */
export const SOCKET_URL = API_BASE_URL || 'http://127.0.0.1:9090';

/** Build a full URL for modules that use raw axios (same rules as API_BASE_URL). */
export function apiUrl(path) {
    const normalized = path.startsWith('/') ? path : `/${path}`;
    if (!API_BASE_URL) return normalized;
    return `${API_BASE_URL}${normalized}`;
}
